/* global axios */
const _form = {
	el: {
		loginTitle: $('.authentication__title'),
		form: $('.js-form'),
		submitBtn: $('.js-submit'),
		uploadBtn: $('.btn--upload'),
		register: $('.js-register'),
		checkbox: $('.form--field__checkbox').find('input'),
		msgSuccess: $('.form__success-message'),
		newPassBtn: $('.authentication__forgot-password'),
		cancelRegister: $('.authentication__cancel')
	},

	formToJson(elem) {
		const unindexed_array = $(elem).serializeArray(),
			indexed_array = {}

		$.map(unindexed_array, (n, i) => {
			$(n).each(() => {
				(n.value === 'true' || n.value === 'false' ? n.value = JSON.parse(n.value) : '')
			})
			indexed_array[n['name']] = n['value']
		})

		return indexed_array
	},

	nextStep(el) {
		if (el.className === 'js-register') {
			$(el).closest('.js-form').toggleClass('hidden').next().toggleClass('hidden')
			this.el.loginTitle.text('registo');

		} else if (el.className === 'authentication__forgot-password') {
			$(el).closest('.js-form').toggleClass('hidden').nextUntil('.general-content__confirmation').not('.general-content__success').not('.authentication__signup').toggleClass('hidden')
			this.el.loginTitle.text('recuperar password');

		} else if (el.className === 'authentication__cancel') {
			$(el).closest('.js-form').toggleClass('hidden').prevAll().not('.authentication__signup').toggleClass('hidden')
			this.el.loginTitle.text('log in');

		} else {
			$(el).closest('.js-form').toggleClass('hidden').siblings().not('.hidden').toggleClass('hidden')
		}
		if (!this.el.form.valid())
			return false
	},

	goRegister() {
		this.el.register.on('click', e => {
			e.preventDefault()
			this.nextStep(e.currentTarget)
		})

		this.el.cancelRegister.on('click', e => {
			e.preventDefault()
			this.nextStep(e.currentTarget)
		})

		this.el.newPassBtn.on('click', e => {
			e.preventDefault()
			this.nextStep(e.currentTarget)
		})
	},

	formEvents() {

		const requiredMessage = $('.js-form').attr('data-msg-required')

		// override default validator messages
		$.validator.messages = {
			...$.validator.messages,
			required: requiredMessage
		}

		this.el.form.validate({
			ignore: ':hidden:not(.js-validate)',

			errorPlacement(error, element) {
				element.attr('type') === 'checkbox' ? $(element).parent().append(error) : error.insertAfter(element)
				if (element.attr('type') === 'checkbox') {
					$(element).parent().append(error)
				} else if (element.attr('id') === 'file') {
					error.insertAfter($(element).siblings('.btn--upload'))
				} else {
					error.insertAfter(element)
				}
			}
		})
		this.el.form.each((i, el) => {
			$(el).on('submit', e => {
				e.preventDefault()

				$(e.currentTarget).find('.js-submit').attr('disabled', true)
				const isValid = $(e.currentTarget).valid()
				grecaptcha = window.grecaptcha,
					recaptcha = $('#recaptcha')

				recaptcha.val(grecaptcha.getResponse())

				if (!isValid) {
					$(e.currentTarget).find('.js-submit').attr('disabled', false)
					return false
				} else
					this.fxAddPreloader(e.currentTarget)

				const formData = this.formToJson(e.currentTarget)


				$.ajax({
					url: this.el.form.data('endpoint'),
					type: 'POST',
					data: JSON.stringify(this.formToJson(e.currentTarget)),
					contentType: 'application/json',
					dataType: 'json',
					beforeSend: function (data) {
						console.log(data)
					},

				}).done((data, textStatus, jqXHR) => {
					if (jqXHR.status === 200) {
						$(el).find('.js-submit').hide()
						console.log(this.el.form.data('msg-success'));
						$('.form__success-message').html(this.el.form.data('msg-success')).fadeIn(200)
						setTimeout(() => {
							grecaptcha.reset()
							$('.form__success-message').html('').fadeOut(100)
							if (document.getElementById('js-file-clear')) {
								document.getElementById('js-file-clear').click();
							}
							$(el).find('.js-submit').attr('disabled', false).fadeIn(200)
							$(el)[0].reset()
						}, 5000)
					}
				})
					.progress((data, textStatus, jqXHR) => {
						this.fxAddPreloader(e.currentTarget)
					})

					.fail((data, textStatus, jqXHR) => {
						console.log(data)
						this.nextStep($(el).next().find('.js-submit'))
						this.el.submitBtn.hide()
						this.el.msgSuccess.html(this.el.form.data('msg-fail')).fadeIn(200)
						setTimeout(() => {
							this.el.msgSuccess.html('').fadeOut(200)
							this.el.submitBtn.attr('disabled', false).fadeIn(200)
						}, 5000)
					})
			})
		})
	},

	validations() {
		const invalidFormatMessage = $('.js-form').attr('data-msg-invalidFormat')

		$.validator.addMethod('recaptcha', () => {
			const grecaptcha = window.grecaptcha || null
			return !grecaptcha || grecaptcha.getResponse()
		})

		$.validator.addMethod('lettersonly', value => {
			return /^([^0-9]*)$/.test(value)
		}, invalidFormatMessage)

		$.validator.addMethod('phone', function (value, element) {
			return this.optional(element) || /^(\+?)(?:[0-9]?){8,11}[0-9]$/.test(value)
		}, invalidFormatMessage)

		$.validator.addMethod('email', value => {
			return (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/i.test(value))
		}, invalidFormatMessage)

		$.validator.addMethod('date', value => {
			return (/^(19\d\d|20[0-9]\d)-((0\d)|(1[012]))-(([012]\d)|3[01])$/.test(value))
		}, invalidFormatMessage)
	},

	uploadFile() {
		this.el.uploadBtn.on('click', e => $(e.currentTarget).siblings('input').click())
	},

	fileUploader: function () {
		_form.el.form.find('input[type=file]').each(function () {
			const input = $(this)
			//Upload trigger
			input.on('change', function (e) {
				const formData = new FormData()
				formData.append('file', this.files[0])

				const limitUploadSize = 104857600 //10MB
				if (this.files[0].size > 0 && this.files[0].size < limitUploadSize) {

					//Upload Ajax Request
					const extension = input.val().split('.').pop()

					if (extension === 'pdf') {
						$.ajax({
							url: _form.el.form.data('upload-endpoint'),
							type: 'POST',
							processData: false,
							contentType: false,
							data: formData,
							beforeSend: () => {
								$('.btn--upload .uploading').css('visibility', 'visible')
								$('.btn--upload img').css('visibility', 'hidden')
								$('.btn--upload span').css('visibility', 'hidden')
							},
							complete: () => {
								$('.btn--upload .uploading').css('visibility', 'hidden')
								$('.btn--upload img').css('visibility', 'visible')
								$('.btn--upload span').css('visibility', 'visible')
							},
							xhr: () => {
								const xhr = new window.XMLHttpRequest()
								xhr.upload.addEventListener("progress", (evt) => {
									if (evt.lengthComputable) {
										const percentComplete = (evt.loaded / evt.total) * 100
										$('.btn--upload .uploading').css('right', (100 - parseInt(percentComplete)) + '%')
									}
								}, false)
								return xhr
							}
						}).done((data, textStatus, jqXHR) => {
							console.log('success', jqXHR)
							//---- Valid Response
							if (jqXHR.status == 200) {
								input.siblings('.btn--upload').addClass('uploaded')
								console.log('attachid:', jqXHR.responseText)
								document.getElementById("AttachmentId").setAttribute('value', jqXHR.responseText)
								console.log($('#AttachmentId'))
								// Show filename & clear button
								input.siblings('.form__uploaded-file').text(formData.get('file').name)
								input.siblings('.js-file-clear').show()
								input.siblings('.btn--upload').children('img').attr('src', '/assets/img/icons/uploaded.svg').show()
								input.siblings('.btn--upload').children('span').text('carregado')
								input.siblings(':hidden').val() === '' ? input.siblings('.error').remove() : ''
								input.siblings(':hidden').val(jqXHR.responseText)

								// clear filename
								input.siblings('.js-file-clear').on('click', function () {
									$(this).hide()
									input.val('')
									input.siblings(':hidden').val('')
									input.attr('disabled', false)
									input.siblings('.form__uploaded-file').text('')
									input.siblings('.btn--upload').removeClass('uploaded')
									input.siblings('.btn--upload').children('img').attr('src', '/assets/img/icons/upload-file.svg')
									input.siblings('.btn--upload').children('span').text('upload de CV*')
								})
							}
						}).fail((jqXHR, textStatus, errorThrown) => {
							input.attr('disabled', true)
							input.siblings('.form__uploaded-file').text('Erro no carregamento.').show()
							setTimeout(() => {
								input.attr('disabled', false)
								input.siblings('.form__uploaded-file').text('')
								_form.resetUploadButton(input)
							}, 5000)
						})
					} else {
						_form.resetUploadButton(input)
						input.siblings('.form__uploaded-file').html(input.closest('form').data('msg-extension')).addClass('error')
						setTimeout(function () {
							input.attr('disabled', false).siblings('.form__uploaded-file').html('').removeClass('error')
						}, 5000)
					}

				} else {
					_form.resetUploadButton(input)
					input.siblings('.form__uploaded-file').text('Tamanho máximo: 10MB').show()
					setTimeout(function () {
						input.attr('disabled', false).siblings('.form__uploaded-file').removeClass('error')
					}, 5000)
				}
			})
		})
	},

	fxInputEvents() {
		this.el.checkbox.on('change', e => $(e.currentTarget).prop('checked') ? $(e.currentTarget).val('true') : $(e.currentTarget).val('false'))
	},

	fxAddPreloader(el) {
		$(el).find('.js-submit').attr('disabled', true).addClass('btn--loading')
		$(el).find('.btn--loading').append('<div class="btn--loading-spinner"></div>')
	},

	fxRemovePreloader(el) {
		$(el).find('.js-submit').attr('disabled', false).removeClass('btn--loading')
		$(el).find('.btn--loading-spinner').remove()
	},

	resetUploadButton(input) {
		input.siblings('.btn--upload').children('img').show()
		input.siblings('.btn--upload').removeClass('uploaded')
		input.siblings('.btn--upload').children('span').text('upload de CV*')
	},

	init() {
		this.formEvents()
		this.validations()
		this.fileUploader()
		this.goRegister()
		this.uploadFile()

	}
}

_form.init()